import type { WidgetSettings } from '@wu/widget-core';
import { pick } from 'es-toolkit';

export function pickFreeLinkSettings<T, V extends WidgetSettings<T>>(
  settings: V
) {
  return pick(settings, [
    'displayFreeLink',
    'displayFreeLinkRemove',
    'freeLinkAnchor',
    'freeLinkURL',
    'freeLinkRemoveURL'
  ]);
}
